module.exports = __webpack_public_path__ + "static/media/ucon4.b4efb41e.JPG";